import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { mpsRouteNames } from '../../mps-route-names';
import { MpsUserService } from '../../services/mps-user.service';
import { MpsNavigationComponent } from '../mps-navigation/mps-navigation.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'mps-app-header',
  templateUrl: './mps-header.component.html',
  styleUrls: ['./mps-header.component.scss'],
  imports: [TranslateModule, MatMenuModule, MatIconModule, MpsNavigationComponent, CommonModule, RouterModule],
})
export class MpsHeaderComponent {
  @Input() public nav?: MatSidenav;
  userService = inject(MpsUserService);
  translateService = inject(TranslateService);
  user = signal(this.userService.getUserSubject().getValue());
  isDropdownOpen = signal(false);
  logoutRoute = mpsRouteNames.auth + '/' + mpsRouteNames.logout;

  isEnvProd: boolean = environment.production;
  envName: string = environment.envName;

  private readonly _eRef = inject(ElementRef);

  getCurrentLangLabel(): string {
    return this.getLangLabel(this.translateService.currentLang);
  }

  getLangLabel(lang: string): string {
    const labels: Record<string, string> = {
      fr: 'Français',
      en: 'English',
    };
    return labels[lang] || this.translateService.instant('general.missing_translation');
  }

  toggleDropdown() {
    this.isDropdownOpen.set(!this.isDropdownOpen());
  }

  switchLanguage(language: string) {
    this.translateService.use(language);
    const user = this.userService.getUser();
    localStorage.setItem('lang', language);
    if (user) {
      this.userService.changeLang(user.id, language)?.subscribe();
    }
  }

  getUserDisplayName() {
    return this.user()?.first_name + ' ' + this.user()?.last_name.substring(0, 1) + '.';
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (!this._eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen.set(false);
    }
  }
}
